

































import Vue from 'vue';
import OctCardContainer from "@/common/components/OctCardContainer.vue";
import { mapGetters } from "vuex";
import { LOGGEDINUSER, CHANGE_LANGUAGE } from '@/common/store/modules/auth';

export default Vue.extend({
  name: 'settings',
  components: {
    OctCardContainer,
  },
  data() {
    return {
      selectedLanguage: {
        text: this.$t('language_de'),
        value: 'de'
      },
      brokers: ['LYNX', 'AGORA', 'CAP_TRADER', 'SAXO_BANK']
    };
  },
  computed: {
    LOGGEDINUSER() {
      return this.$store.getters['LOGGEDINUSER'];
    },
    CHANGE_BROKER_ALLOWED() {
      return this.$store.getters['CHANGE_BROKER_ALLOWED'];
    },
    BROKER: {
      // getter
      get () {
        return this.$store.getters['BROKER'];
      },
      // setter
      set (newValue) {
        this.$store.commit('UPDATE_BROKER', newValue);
      }
    },
    languages() {
      return [
        {
          text: this.$t('language_de'),
          value: 'de'
        },
        {
          text: this.$t('language_en'),
          value: 'en'
        }
      ];
    }
  },
  watch: {
    selectedLanguage (newValue) {
      if(! newValue.text) {
        this.$store.commit(CHANGE_LANGUAGE, newValue);
      }
    }
  },
  mounted(): void {
    this.selectedLanguage = {
      text: this.$t('language_' + this.LOGGEDINUSER.language),
      value: this.LOGGEDINUSER.language
    };
  }
});
